module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-get-start-first-visit"
  }, [_c('div', {
    staticClass: "custom-get-start-first-visit__container"
  }, [_c('Title', {
    attrs: {
      "props": _vm.props.intro
    }
  }), _c('div', {
    staticClass: "custom-get-start-first-visit__img-row"
  }, [_c('v-waypoint', {
    staticClass: "custom-get-start-first-visit__waypoint",
    on: {
      "waypoint-in": function($event) {
        _vm.fadeUp()
      }
    }
  }), _c('div', {
    staticClass: "custom-get-start-first-visit__col--left",
    domProps: {
      "innerHTML": _vm._s(_vm.props.top.content)
    }
  }), _c('div', {
    ref: "img",
    staticClass: "custom-get-start-first-visit__col--right"
  }, [_c('img', {
    attrs: {
      "src": _vm.props.top.img
    }
  })])], 1), _c('div', {
    staticClass: "custom-get-start-first-visit__btm-row",
    domProps: {
      "innerHTML": _vm._s(_vm.props.bottom.content)
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-534971ac","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-get-start-first-visit/custom-get-start-first-visit.pug
// module id = 1121
// module chunks = 1